import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'reactstrap';
import { normalizeBrand } from "../../../utils/Helpers"

const Breadcrumbs = props => {
  const { dataProduct } = props;
  const hasData = dataProduct.id !== null && dataProduct.id !== undefined;
  const category = hasData ? (dataProduct.product ? (dataProduct.product.category ? dataProduct.product.category.name : 'Sneakers') : 'Sneakers') : 'Sneakers';
  const categoryUrl = category === "apparels" || category === "Apparels" ? "apparel" : category === "lifestyles" ? "electronics-collectibles" : category === "handbags" ? "luxury" : category;
  return (
    <div>
      {
        hasData ?
          <Breadcrumb tag="nav" listtag="div">
            <span className="breadcrumb-item">{categoryUrl}</span>
            {
              dataProduct.product.brand && dataProduct.product.brand.ancestors.length ?
                <Link
                  className="breadcrumb-item"
                  to={`/${categoryUrl.trim().toLowerCase()}/search/${dataProduct.product.brand.ancestors[0].name.trim().replace(' ', '+').toLowerCase()}?brands=${dataProduct.product.brand.ancestors[0].id}`}
                >
                  <span className="bold-breadcrumb">{dataProduct.product.brand.ancestors[0].name}</span>
                </Link>
                : null
            }
            {
              dataProduct.product.brand ?
                <Link
                  className="breadcrumb-item"
                  to={`/${categoryUrl.trim().toLowerCase()}/search/${dataProduct.product.brand.name.trim().replace(' ', '+').toLowerCase()}?brands=${dataProduct.product.brand_id}`}
                >
                  <span className="bold-breadcrumb">{normalizeBrand(dataProduct.product.brand.title ? dataProduct.product.brand.title : dataProduct.product.brand.name)}</span>
                </Link>
                : null
            }

            <Link className="breadcrumb-item" to={`/${categoryUrl.trim().toLowerCase()}/${dataProduct.id}/${dataProduct.slug}`}><span className="bold-breadcrumb">{dataProduct.display_name}</span></Link>

            {/* <span className="breadcrumb-item" href="#">{dataProduct.display_name}</span> */}
            {/* <BreadcrumbItem tag="a"></BreadcrumbItem> */}
            {/* <BreadcrumbItem tag="a"></BreadcrumbItem> */}
          </Breadcrumb>
          : null
      }
    </div>
  )
}

export default Breadcrumbs;
Breadcrumbs.defaultProps = {
  dataProduct: {
    id: null
  }
}